import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import PunchCardItem from './PunchCardItem';

const { UI } = Mobi2Go;

const base_class = 'm2g-order-loyalty-punch-card';

const PunchCardCompact = ({
    title,
    description,
    terms_and_conditions,
    num_punches_needed,
    punches,
}) => {
    const [t] = useTranslation('order.loyalty');

    const onClickTermsAndConditions = useCallback(() => {
        UI.centeredAlert({
            title: t('terms_and_conditions'),
            body: terms_and_conditions,
        });
    }, [t, terms_and_conditions]);

    return (
        <div className={base_class}>
            <div className={`${base_class}-program-container`}>
                <div
                    className={clsx(
                        `${base_class}-icon`,
                        'm2g-icon',
                        'm2g-icon--award',
                        'm2g-icon--medium'
                    )}
                />
                <div className={`${base_class}-title`}>{title}</div>
                {description && (
                    <div
                        className={clsx(
                            `${base_class}-description`,
                            'm2g-text--offset',
                            'm2g-text--small'
                        )}
                    >
                        {description}
                    </div>
                )}
                {terms_and_conditions && (
                    <button
                        type="button"
                        className={clsx(
                            `${base_class}-terms-and-conditions`,
                            'm2g-text--link',
                            'm2g-text--offset',
                            'm2g-text--small'
                        )}
                        onClick={onClickTermsAndConditions}
                    >
                        {t('terms_and_conditions')}
                    </button>
                )}
            </div>

            <div className={`${base_class}-punches-container`}>
                <div className={`${base_class}-punches`}>
                    {[...Array(num_punches_needed).keys()].map(index => (
                        <PunchCardItem
                            key={index}
                            num={index + 1}
                            isPunched={index < punches}
                            baseClass={base_class}
                        />
                    ))}
                </div>

                <div className={`${base_class}-punch-count-progress`}>
                    <div
                        className={`${base_class}-punch-count-progress-number-container`}
                    >
                        <span
                            className={`${base_class}-punch-count-progress-number`}
                        >
                            {punches}
                        </span>
                    </div>

                    <div className={`${base_class}-punch-count-progress-bar`}>
                        <div
                            className={`${base_class}-punch-count-progress-bar-label`}
                        >
                            {title}
                        </div>
                        <div
                            className={`${base_class}-punch-count-progress-bar-container`}
                        >
                            <div
                                className={clsx(
                                    `${base_class}-punch-count-progress-bar-content`,
                                    `${base_class}-punch-count-progress-bar-content--earned`
                                )}
                                style={{
                                    width: `${(punches / num_punches_needed) *
                                        100}%`,
                                }}
                            />
                            <div
                                className={`${base_class}-punch-count-progress-bar-content ${base_class}-punch-count-progress-bar-content--earned-with-this-order`}
                                style={{
                                    width: `${(punches / num_punches_needed) *
                                        100}%`,
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PunchCardCompact.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    terms_and_conditions: PropTypes.string.isRequired,
    num_punches_needed: PropTypes.number.isRequired,
    // punch_label: PropTypes.string.isRequired,
    // punch_label_plural: PropTypes.string.isRequired,
    punches: PropTypes.number.isRequired,
};

export default PunchCardCompact;
